import { render, staticRenderFns } from "./vSelectAreaLab.vue?vue&type=template&id=b6b2aa60&"
import script from "./vSelectAreaLab.vue?vue&type=script&lang=js&"
export * from "./vSelectAreaLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports